import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
import { assignProps as _assignProps5 } from 'intergalactic/core';
import { assignProps as _assignProps4 } from 'intergalactic/core';
import { assignProps as _assignProps3 } from 'intergalactic/core';
import { assignProps as _assignProps2 } from 'intergalactic/core';
import { assignProps as _assignProps } from 'intergalactic/core';
var _excluded = ["Children", "options", "multiselect", "value", "uid", "forcedAdvancedMode"];
import React from 'react';
import cn from 'classnames';
import createComponent, { Component, Root, sstyled } from 'intergalactic/core';
import DropdownMenu from 'intergalactic/dropdown-menu';
import { ButtonTrigger } from 'intergalactic/base-trigger';
import Divider from 'intergalactic/divider';
import findComponent from 'intergalactic/utils/lib/findComponent';
import logger from 'intergalactic/utils/lib/logger';
import resolveColorEnhance from 'intergalactic/utils/lib/enhances/resolveColorEnhance';
import addonTextChildren from 'intergalactic/utils/lib/addonTextChildren';
import InputSearch from './InputSearch';
import { useBox } from 'intergalactic/flex-box';
import { selectContext } from './context';
import uniqueIDEnhancement from 'intergalactic/utils/lib/uniqueID';
import i18nEnhance from 'intergalactic/utils/lib/enhances/i18nEnhance';
import { localizedMessages } from './translations/__intergalactic-dynamic-locales';
import { isInputTriggerTag } from 'intergalactic/popper';
/*__reshadow-styles__:"./style/select.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SOptionCheckbox_1i8zb_gg_{margin-top:var(--intergalactic-spacing-05x, 2px);margin-right:var(--intergalactic-spacing-2x, 8px);margin-bottom:auto;position:relative;flex-shrink:0;width:16px;height:16px}.___SOptionCheckbox_1i8zb_gg_::before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;background:var(--intergalactic-bg-primary-neutral, #ffffff);border:1px solid;border-radius:var(--intergalactic-addon-rounded, 4px);border-color:var(--intergalactic-border-primary, #c4c7cf)}.___SOptionCheckbox_1i8zb_gg_::after{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;margin:0 var(--intergalactic-spacing-05x, 2px);background-repeat:no-repeat;background-position:center center}.___SOptionCheckbox_1i8zb_gg_.__selected_1i8zb_gg_::after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEwIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjI1IDFMNCA1LjI1TDEuNzUgMyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==)}.___SOptionCheckbox_1i8zb_gg_._size_l_1i8zb_gg_{width:20px;height:20px}.___SOptionCheckbox_1i8zb_gg_._size_l_1i8zb_gg_.__selected_1i8zb_gg_::after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEyIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMSAxLjVMNC43NSA3Ljc1TDEgNCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==)}.___SOptionCheckbox_1i8zb_gg_.__indeterminate_1i8zb_gg_:before,.___SOptionCheckbox_1i8zb_gg_.__selected_1i8zb_gg_:before{background-color:var(--intergalactic-control-primary-info, #008ff8);border-color:var(--intergalactic-control-primary-info, #008ff8)}.___SOptionCheckbox_1i8zb_gg_.__theme_1i8zb_gg_:before{border-color:var(--theme_1i8zb)}.___SOptionCheckbox_1i8zb_gg_.__theme_1i8zb_gg_.__indeterminate_1i8zb_gg_:before,.___SOptionCheckbox_1i8zb_gg_.__theme_1i8zb_gg_.__selected_1i8zb_gg_:before{background-color:var(--theme_1i8zb);border-color:var(--theme_1i8zb)}.___SOptionCheckbox_1i8zb_gg_.__selected_1i8zb_gg_{background-color:var(--intergalactic-dropdown-menu-item-selected, rgba(196, 229, 254, 0.7))}@media (hover:hover){.___SOptionCheckbox_1i8zb_gg_.__selected_1i8zb_gg_:hover{background-color:var(--intergalactic-dropdown-menu-item-selected-hover, #c4e5fe)}}.___SOptionCheckbox_1i8zb_gg_.__indeterminate_1i8zb_gg_:after{background-color:#fff;background-image:none;margin:auto;border-radius:1px}.___SOptionCheckbox_1i8zb_gg_.__indeterminate_1i8zb_gg_._size_l_1i8zb_gg_:after{width:12px;height:2px}.___SOptionCheckbox_1i8zb_gg_.__indeterminate_1i8zb_gg_._size_m_1i8zb_gg_:after{width:8px;height:2px}" /*__inner_css_end__*/, "1i8zb_gg_") /*__reshadow_css_end__*/, {
  "__SOptionCheckbox": "___SOptionCheckbox_1i8zb_gg_",
  "_selected": "__selected_1i8zb_gg_",
  "_size_l": "_size_l_1i8zb_gg_",
  "_indeterminate": "__indeterminate_1i8zb_gg_",
  "_theme": "__theme_1i8zb_gg_",
  "--theme": "--theme_1i8zb",
  "_size_m": "_size_m_1i8zb_gg_"
});
function isSelectedOption(value, valueOption) {
  return Array.isArray(value) ? value.includes(valueOption) : valueOption === value;
}
function isEmptyValue(value) {
  return Array.isArray(value) ? value.length === 0 : value === null;
}
function getEmptyValue(multiselect) {
  return multiselect ? [] : null;
}
var scrollToNode = function scrollToNode(node) {
  if (!node) return;
  if (!node.scrollIntoView) return;
  node.scrollIntoView({
    block: 'nearest',
    inline: 'nearest'
  });
};
var RootSelect = /*#__PURE__*/function (_Component) {
  _inherits(RootSelect, _Component);
  var _super = _createSuper(RootSelect);
  function RootSelect() {
    var _this;
    _classCallCheck(this, RootSelect);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "firstSelectedOptionRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "triggerRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "isScrolledToFirstOption", false);
    _defineProperty(_assertThisInitialized(_this), "lastHandleOptionNodeCall", -1);
    _defineProperty(_assertThisInitialized(_this), "handleOptionNode", function (node) {
      if (!_this.asProps.scrollToSelected) return;
      if (Date.now() - _this.lastHandleOptionNodeCall < 30) return;
      _this.lastHandleOptionNodeCall = Date.now();
      setTimeout(function () {
        // in most cases 10ms timeout works perfectly and scrolls before user can see it
        if (_this.asProps.visible) scrollToNode(node);
      }, 10);
      setTimeout(function () {
        // in rare cases 10ms timeout it not enough so 30ms timeout saves the day
        if (_this.asProps.visible) scrollToNode(node);
      }, 30);
    });
    _defineProperty(_assertThisInitialized(_this), "bindHandlerOptionClick", function (optionValue) {
      return function (e) {
        var newValue = optionValue;
        var _this$asProps = _this.asProps,
          value = _this$asProps.value,
          multiselect = _this$asProps.multiselect,
          interaction = _this$asProps.interaction;
        if (Array.isArray(value)) {
          if (value.includes(optionValue)) {
            newValue = value.filter(function (v) {
              return v !== optionValue;
            });
          } else {
            newValue = value.concat(optionValue);
          }
        }
        _this.handlers.value(newValue, e);
        if (!multiselect) {
          _this.handlers.visible(false);
        }
      };
    });
    _defineProperty(_assertThisInitialized(_this), "handlerClear", function (e) {
      var value = _this.asProps.value;
      var emptyValue = getEmptyValue(Array.isArray(value));
      _this.handlers.value(emptyValue, e);
      _this.handlers.visible(false);
    });
    return _this;
  }
  _createClass(RootSelect, [{
    key: "uncontrolledProps",
    value: function uncontrolledProps() {
      return {
        visible: null,
        value: null
      };
    }
  }, {
    key: "getTriggerProps",
    value: function getTriggerProps() {
      var _this$asProps2 = this.asProps,
        size = _this$asProps2.size,
        disabled = _this$asProps2.disabled,
        visible = _this$asProps2.visible,
        state = _this$asProps2.state,
        placeholder = _this$asProps2.placeholder,
        value = _this$asProps2.value,
        options = _this$asProps2.options,
        forwardRef = _this$asProps2.forwardRef,
        name = _this$asProps2.name,
        multiselect = _this$asProps2.multiselect,
        uid = _this$asProps2.uid,
        disablePortal = _this$asProps2.disablePortal,
        getI18nText = _this$asProps2.getI18nText;
      return {
        id: "igc-".concat(uid, "-trigger"),
        'aria-controls': visible ? "igc-".concat(uid, "-list") : undefined,
        focusHint: visible && !disablePortal ? getI18nText('triggerHint') : undefined,
        'aria-haspopup': 'listbox',
        'aria-expanded': visible ? 'true' : 'false',
        'aria-disabled': disabled ? 'true' : 'false',
        empty: isEmptyValue(value),
        size: size,
        value: value,
        name: name,
        $hiddenRef: forwardRef,
        multiselect: multiselect,
        state: state,
        placeholder: placeholder,
        disabled: disabled,
        active: visible,
        onClear: this.handlerClear,
        children: this.renderChildrenTrigger(value, options),
        getI18nText: getI18nText,
        ref: this.triggerRef
      };
    }
  }, {
    key: "getListProps",
    value: function getListProps() {
      var _this$asProps3 = this.asProps,
        multiselect = _this$asProps3.multiselect,
        uid = _this$asProps3.uid;
      return {
        'aria-multiselectable': multiselect ? 'true' : undefined,
        id: "igc-".concat(uid, "-list"),
        role: 'listbox',
        'aria-label': 'List of options'
      };
    }
  }, {
    key: "getMenuProps",
    value: function getMenuProps() {
      var _this$asProps4 = this.asProps,
        uid = _this$asProps4.uid,
        getI18nText = _this$asProps4.getI18nText,
        multiselect = _this$asProps4.multiselect;
      return {
        'aria-multiselectable': multiselect ? 'true' : undefined,
        id: "igc-".concat(uid, "-list"),
        role: 'listbox',
        'aria-label': getI18nText('optionsList')
      };
    }
  }, {
    key: "getOptionProps",
    value: function getOptionProps(props) {
      var value = this.asProps.value;
      var selected = isSelectedOption(value, props.value);
      var other = {};
      if (selected) {
        other.ref = this.handleOptionNode;
      }
      return _objectSpread({
        selected: selected,
        'aria-selected': selected ? 'true' : 'false',
        'aria-disabled': props.disabled ? 'true' : 'false',
        role: 'option',
        onClick: this.bindHandlerOptionClick(props.value)
      }, other);
    }
  }, {
    key: "getOptionCheckboxProps",
    value: function getOptionCheckboxProps() {
      var _this$asProps5 = this.asProps,
        size = _this$asProps5.size,
        resolveColor = _this$asProps5.resolveColor;
      return {
        size: size,
        resolveColor: resolveColor
      };
    }
  }, {
    key: "getDividerProps",
    value: function getDividerProps() {
      return {
        my: 1,
        'aria-disabled': 'true'
      };
    }
  }, {
    key: "renderChildrenTrigger",
    value: function renderChildrenTrigger(value, options) {
      if (options) {
        return [].concat(value).reduce(function (acc, value) {
          var selectedOption = options.find(function (o) {
            return isSelectedOption(value, o.value);
          });
          if (!selectedOption) return acc;
          if (acc.length) acc.push(', ');
          acc.push(selectedOption.label || selectedOption.value);
          return acc;
        }, []);
      }
      return Array.isArray(value) ? value.reduce(function (acc, value) {
        if (acc.length) acc.push(', ');
        acc.push(value);
        return acc;
      }, []) : value;
    }
  }, {
    key: "render",
    value: function render() {
      var _ref2 = this.asProps;
      var _this$asProps6 = this.asProps,
        Children = _this$asProps6.Children,
        options = _this$asProps6.options,
        multiselect = _this$asProps6.multiselect,
        value = _this$asProps6.value,
        uid = _this$asProps6.uid,
        forcedAdvancedMode = _this$asProps6.forcedAdvancedMode,
        other = _objectWithoutProperties(_this$asProps6, _excluded);
      var advancedMode = forcedAdvancedMode || findComponent(Children, [Select.Trigger.displayName, Select.Popper.displayName]);
      logger.warn(options && advancedMode, "Don't use at the same time 'options' property and '<Select.Trigger/>/<Select.Popper/>'", other['data-ui-name'] || Select.displayName);
      if (options) {
        var _ref = this.asProps;
        return /*#__PURE__*/React.createElement(DropdownMenu, _assignProps({}, _ref), /*#__PURE__*/React.createElement(Select.Trigger, other), /*#__PURE__*/React.createElement(Select.Menu, null, options.map(function (option, index) {
          return /*#__PURE__*/React.createElement(Select.Option, _extends({
            key: option.value,
            id: "igc-".concat(uid, "-option-").concat(index)
          }, option), multiselect && /*#__PURE__*/React.createElement(Select.Option.Checkbox, null), option.children);
        })));
      }
      return /*#__PURE__*/React.createElement(DropdownMenu, _assignProps2({}, _ref2), /*#__PURE__*/React.createElement(Children, null));
    }
  }]);
  return RootSelect;
}(Component);
_defineProperty(RootSelect, "displayName", 'Select');
_defineProperty(RootSelect, "style", style);
_defineProperty(RootSelect, "enhance", [uniqueIDEnhancement(), i18nEnhance(localizedMessages), resolveColorEnhance()]);
_defineProperty(RootSelect, "defaultProps", function (props) {
  return {
    placeholder: props.multiselect ? 'Select options' : 'Select option',
    size: 'm',
    defaultValue: getEmptyValue(props.multiselect),
    defaultVisible: false,
    scrollToSelected: true,
    i18n: localizedMessages,
    locale: 'en'
  };
});
function Trigger(_ref8) {
  var _ref3 = arguments[0],
    _ref6;
  var Children = _ref8.Children,
    name = _ref8.name,
    value = _ref8.value,
    styles = _ref8.styles,
    $hiddenRef = _ref8.$hiddenRef,
    _ref8$tag = _ref8.tag,
    Tag = _ref8$tag === void 0 ? ButtonTrigger : _ref8$tag,
    getI18nText = _ref8.getI18nText;
  var hasInputTrigger = isInputTriggerTag(Tag);
  var SSelectTrigger = DropdownMenu.Trigger;
  return _ref6 = sstyled(styles), /*#__PURE__*/React.createElement(SSelectTrigger, _ref6.cn("SSelectTrigger", _objectSpread({}, _assignProps3({
    "tag": Tag,
    "placeholder": getI18nText('selectPlaceholder'),
    "aria-autocomplete": hasInputTrigger && 'list' || undefined
  }, _ref3))), addonTextChildren(Children, Tag.Text || ButtonTrigger.Text, Tag.Addon || ButtonTrigger.Addon, true), name && /*#__PURE__*/React.createElement("input", _ref6.cn("input", {
    "type": 'hidden',
    "defaultValue": value,
    "name": name,
    "ref": $hiddenRef
  })));
}
var optionPropsContext = /*#__PURE__*/React.createContext({});
function Option(props) {
  var _ref4 = arguments[0],
    _ref7;
  var SSelectOption = DropdownMenu.Item;
  var styles = props.styles,
    Children = props.Children;
  return _ref7 = sstyled(styles), /*#__PURE__*/React.createElement(SSelectOption, _ref7.cn("SSelectOption", _objectSpread({}, _assignProps4({}, _ref4))), /*#__PURE__*/React.createElement(optionPropsContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(Children, _ref7.cn("Children", {}))));
}
function Checkbox(providedProps) {
  var optionProps = React.useContext(optionPropsContext);
  var props = React.useMemo(function () {
    return _objectSpread({
      selected: optionProps === null || optionProps === void 0 ? void 0 : optionProps.selected,
      disabled: optionProps === null || optionProps === void 0 ? void 0 : optionProps.disabled,
      size: optionProps === null || optionProps === void 0 ? void 0 : optionProps.size
    }, providedProps || {});
  }, [providedProps, optionProps]);
  var _useBox = useBox(props, props.forwardRef),
    _useBox2 = _slicedToArray(_useBox, 2),
    SOptionCheckbox = _useBox2[0],
    componentProps = _useBox2[1];
  var size = props.size,
    theme = props.theme,
    selected = props.selected,
    resolveColor = props.resolveColor,
    indeterminate = props.indeterminate;
  var styles = sstyled(props.styles);
  var _styles$cn = styles.cn('SOptionCheckbox', {
      size: size,
      'use:theme': resolveColor(theme),
      indeterminate: indeterminate,
      selected: selected
    }),
    className = _styles$cn.className,
    style = _styles$cn.style;
  return /*#__PURE__*/React.createElement(SOptionCheckbox, _extends({}, componentProps, {
    className: cn(className, componentProps.className) || undefined,
    style: _objectSpread(_objectSpread({}, style), componentProps.style),
    tabIndex: -1
  }));
}
var InputSearchWrapper = function InputSearchWrapper() {
  var _ref5 = arguments[0];
  return /*#__PURE__*/React.createElement(InputSearch, _assignProps5({}, _ref5));
};
var Select = createComponent(RootSelect, {
  Trigger: [Trigger, {
    Addon: ButtonTrigger.Addon,
    Text: ButtonTrigger.Text
  }],
  Popper: DropdownMenu.Popper,
  List: DropdownMenu.List,
  Menu: DropdownMenu.Menu,
  Option: [Option, {
    Addon: DropdownMenu.Item.Addon,
    Checkbox: Checkbox
  }],
  OptionTitle: DropdownMenu.ItemTitle,
  OptionHint: DropdownMenu.ItemHint,
  Divider: Divider,
  InputSearch: [InputSearchWrapper, InputSearch._______childrenComponents],
  Input: [InputSearchWrapper, InputSearch._______childrenComponents]
}, {
  parent: DropdownMenu,
  context: selectContext
});
export var wrapSelect = function wrapSelect(wrapper) {
  return wrapper;
};
export default Select;
//# sourceMappingURL=Select.js.map